export default __webpack_public_path__ + "static/stockly-3b4a86373abcae70166574ce22934820.jpeg";